(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("externalQualificationHistoryLearner", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/learnerAccess/learningItemType/history/externalQualificationHistoryLearnerView.html",
            controller: ["assignmentLearnerAccessExternalQualificationResource", "$translate", "$state", "DTOptionsBuilder", ExternalQualificationHistoryLearnerCtrl],
            controllerAs: "vm"
        };
        function ExternalQualificationHistoryLearnerCtrl(assignmentLearnerAccessExternalQualificationResource, $translate, $state, DTOptionsBuilder) {
            var vm = this;
            vm.number = $state.params.number;
            vm.version = $state.params.version;
            vm.code = $state.params.code;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withPaginationType("full_numbers")
                .withOption("order", [1, "desc"])
                .withBootstrap();
            assignmentLearnerAccessExternalQualificationResource.getLearnerAccessHistoryViewModel({ number: vm.number, version: vm.version, code: vm.code }, function (data) {
                vm.externalQualificationsLearner = data.activations;
                vm.learningItemName = data.learningItemName;
            });
        }
    });
}());
